import classNames from 'classnames';
import useCommon from '@utils/hooks/common';
import {Col, Input, InputProps, Row, Select, SelectProps} from 'antd';
import styles from './styles';
import {CaretDownOutlined} from '@ant-design/icons';

type CustomSelectInterface = SelectProps & {className?: string};

const CustomSelect = (props: CustomSelectInterface) => {
  const {classes, t} = useCommon({
    withTranslation: null,
    withStyles: styles,
  });

  const {className, ...restProps} = props;

  const {Option} = Select;

  return (
    <Select
      className={classNames(classes.customSelect, className)}
      popupClassName={classes.customDropdown}
      suffixIcon={<CaretDownOutlined style={{color: 'white', pointerEvents: 'none'}} />}
      {...restProps}
    />
  );
};

export default CustomSelect;
